export default __webpack_public_path__ + "static/media/Gujarati GR_Pani_Samiti_2016.a5fd84fa.pdf";